import { registerRootComponent } from "expo";
import "./datadogRUM-init";

import App from "./App";
registerRootComponent(App);
